import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { getCookie } from "typescript-cookie";
import { useLazyGetDirectionListQuery } from "../../redux/api/handBooksApi/directionApi";
import { BasicHbFilter } from "../../models/filters/basicHbFilter";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { EntDirection } from "../../models/handBooks/direction";

interface IProps {
  value?: number | number[] | null;
  onChange?: (value: number | number[] | null) => void;
  mode?: "multiple" | "tags";
}

const SelectDirectionType = (props: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);

  const [getData] = useLazyGetDirectionListQuery();
  const {
    fetching,
    data,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntDirection, BasicHbFilter>({
    initialFilter: new BasicHbFilter(),
    query: getData
  });

  useEffect(() => {
    const options = Array.from(new Set(data)).map((a) => {
      return { label: getCookie('i18next') === 'ky' ? `${a.nameKy}` : `${a.nameRu}` , value: a.id ?? '' };
    });
    setOptions(options);
  }, [data]);

  const search = (value?: string) => {
    if (!value) return;
    const filter = new BasicHbFilter();
    filter.name = value;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const clear = () => {
    const filter = new BasicHbFilter();
    filter.name = null;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }

  return (
      <Select
          placeholder={t("msg.selectPlaceholder")}
          onClear={clear}
          onSearch={search}
          onPopupScroll={scrollHandler}
          loading={fetching}
          value={props.value}
          onChange={props.onChange}
          options={options}
          filterOption={defaultFilterOption}
          showSearch
          allowClear
          mode={props.mode}
          dropdownRender={(menu) => (
              <Spin spinning={fetching}>
                {menu}
              </Spin>
          )}
      />
  );
};

export default SelectDirectionType;